import FooterQuestionnaire from '@/components/layout-questionnaire/components/footer/footer';
import NavigationBar from '@/components/layout/navigation-bar/navigation-bar';
import Layout from '@/components/layout-questionnaire/layout-questionnaire';
import { Button, Flex, Text } from '@cmpsr/components';
import useQuestionnaireErrorController from './questionnaire-error.controller';

export default function QuestionnaireError({ resetStatus }: { resetStatus: () => void }) {
  const { handleRetry, isRetrying, handleLogOut } = useQuestionnaireErrorController(resetStatus);

  return (
    <Layout background="gradient-04" flex="1">
      <NavigationBar beta />
      <Flex
        as="main"
        pt={{ base: 'spacer-8', lg: 'spacer-12', xl: 'spacer-16' }}
        px={{ base: 'spacer-5', lg: 'spacer-12', xl: 'spacer-16' }}
        justifyContent="flex-start"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        flexGrow="1"
        width={{ base: '100%', lg: '650px' }}
        margin="auto"
        background="none"
      >
        <Text variant="text-header-2XL" color="text-light" mb="spacer-2">
          Hm. Something's{' '}
          <Text as="span" textStyle="text-header-2xl-v" color="text-light">
            not right
          </Text>
        </Text>
        <Text variant="text-body-large-regular" color="text-light">
          We're working to incorporate the latest data into your risk score. Please check back in a few minutes to see
          if the issue is resolved.
        </Text>
        <Button variant="accent" size="l" mt="spacer-12" mb="spacer-4" onClick={handleRetry} isDisabled={isRetrying}>
          Try again
        </Button>
        <Button aria-label="Log out" variant="link-accent" size="m" onClick={handleLogOut}>
          Log out
        </Button>
      </Flex>
      <FooterQuestionnaire />
    </Layout>
  );
}
